<div class="premiereDetailsDiv" fxFlex=25>


    <div class="premiereDetails spotlightDetails" fxLayout="column">

        <div class="premiereDateTop">
            <span class="date">{{premiereDetails.cinejoySpotlightsSchedule[0].scheduleTimeText | date:'EEEE, MMM d, y,
                h:mm:ss a'}} {{timezone}}</span>
        </div>

        <div class="premiereHeading">
            <span class="heading">{{premiereDetails.name}}</span>
            <hr class="premiereHeadingHr" />
        </div>

        <div class="premiereDescription">
            <p class="premiereInfo" [innerHTML]="premiereDetails.description"></p>
            <p class="director">Directed by {{premiereDetails.directors}}</p>
            <p class="cast">{{premiereDetails.cast.join(', ')}}</p>

            <div class="details" fxLayout="row wrap" fxLayoutGap="20%">
                <span class="language">{{premiereDetails.language}}</span>
                <span class="country">{{premiereDetails.country}}</span>
            </div>

            <!-- <div class="tags" fxLayout="row wrap" *ngFor="let tag of tags">
                 <span>{{tag}}</span>
             </div> -->

            <div class="tags" fxLayout="row wrap grid" *ngFor="let tag of premiereDetails.tags">
                <span>{{tag}}</span>
            </div>
        </div>

        <div fxLayout="row wrap grid" fxLayoutGap="10px">

            <button *ngIf="!isBuyButtonActive" (click)="open(premiereDetails.eventId, premiereDetails, 'Buy')"
                class="premierePageButton">Buy</button>
            <button class="premierePageButton" (click)="redirect()" [disabled]="joinButtonDisabled">Join</button>
            <button class="premierePageButton" (click)="openDialog(premiereDetails)" *ngIf="isBuyButtonActive && joinButtonDisabled">
                <ng-container *ngIf="!exsistingGroup">Create Group</ng-container>
                <ng-container *ngIf="exsistingGroup">Manage Group</ng-container></button>
        </div>
        <a class="spotLightsTitle" style="font-size: 16px;color: white;margin-bottom: 5px;" [href]="groupshareUrl"
            target="_blank">Experience Spotlight with Group</a>

        <div class="premiereDateBottom">
            <span class="date">{{premiereDetails.cinejoySpotlightsSchedule[0].scheduleTimeText | date:'EEEE, MMM d, y,
                h:mm:ss a'}} {{timezone}}</span>
        </div>

    </div>

</div>
